import { makeOptional } from "../routeHelper"

export const templates = {
  id: "reports",
  config: "/reports",
  build: () => "/reports",
  children: [
    {
      id: "assessmentPerformance",
      config: "/reports/assessment-performance",
      build: () => "/reports/assessment-performance",
    },
    {
      id: "assessmentPerformanceVersions",
      config: "/reports/assessment-performance/:assessmentId/versions",
      build: (assessmentId) => `/reports/assessment-performance/${assessmentId}/versions`,
    },
    {
      id: "assessmentPerformanceForms",
      config: "/reports/assessment-performance/:assessmentId/versions/:versionId/forms",
      build: (assessmentId, versionId) =>
        `/reports/assessment-performance/${assessmentId}/versions/${versionId}/forms`,
    },
    {
      id: "assessmentPerformanceQuestions",
      config: "/reports/assessment-performance/:assessmentId/versions/:versionId/forms/:formId",
      build: (assessmentId, versionId, formId) =>
        `/reports/assessment-performance/${assessmentId}/versions/${versionId}/forms/${formId}`,
    },
    {
      id: "results",
      config: "/reports/results-tab/:viewType",
      build: (viewType) => `/reports/results-tab/${viewType || 1}`,
      children: [
        {
          id: "reportsCandidateResults",
          config: "/reports/results-tab/:viewType/:parentId/candidate-result",
          build: (parentId, viewType) =>
            `/reports/results-tab/${viewType}/${parentId}/candidate-result`,
        },
        {
          // TODO: THIS IS USED - NEW
          id: "reportsCandidateResult",
          config: "/reports/results-tab/:viewType/:parentId/candidate-result/:resultId/:userId",
          build: (parentId, viewType, resultId, userId) =>
            `/reports/results-tab/${viewType}/${
              parentId || "item"
            }/candidate-result/${resultId}/${userId}`,
        },
        {
          id: "reportsCandidateResultEvaluation",
          config:
            "/reports/results-tab/:viewType/:parentId/:scheduleId/:attemptNumber/evaluate/:examResultId/:userId/:questionId",
          build: ({ viewType, parentId, scheduleId, attemptNumber, examResultId, userId, questionId }) =>
            `/reports/results-tab/${viewType}/${
              parentId || "item"
            }/${scheduleId}/${attemptNumber}/evaluate/${examResultId}/${userId}/${questionId}`,
        },
      ],
    },
    {
      id: "exportCandidatesResults",
      config: "/reports/results/candidates/export",
      build: () => "/reports/results/candidates/export",
    },
    {
      // TODO: THIS IS UNUSED
      id: "candidateResult",
      config: "/reports/results/candidates/:resultId/:userId/:optional?",
      build: (resultId, userId, optional) =>
        `/reports/results/candidates/${resultId}/${userId}${makeOptional(optional)}`,
    },
    {
      id: "exportSchedulesResults",
      config: "/reports/results/schedules/export",
      build: () => "/reports/results/schedules/export",
    },
    {
      // TODO: THIS IS _PROBABLY_ UNUSED
      id: "scheduleResult",
      config: "/reports/results/schedules/:id",
      build: (id) => `/reports/results/schedules/${id}`,
    },
    {
      // TODO: THIS IS UNUSED
      id: "scheduleAssessmentResult",
      config: "/reports/results/schedules/:assessmentId/:id/:subsection?",
      build: (assessmentId, id, subsection) =>
        `/reports/results/schedules/${assessmentId}/${id}${makeOptional(subsection)}`,
    },
  ],
}
